import React from 'react'
import "./cardOfField.css"
function CardOfField(props) {
  return (
    <div className='fieldContainer'>
      <img src={props.image} alt="electronics" className='fieldImage' />
      <h3 className="fieldTitle">{props.title}</h3>
      <button className='detailsFiels'>Details</button>
    </div>
  )
}

export default CardOfField